<template>
  <div class="card-landscape">
    <!-- Помощь по пункту «Пути новичка»: игрок нажал пункт в профиле — показываем, что нажать -->
    <TutorialHelp route="/pvp" />
      <div class="pvp__headers">
        <div class="pvp__header">
          {{ $t('pvp.gameMode') }}
        </div>
        <!-- Глазик внутри headers → вертикально центрируется с заголовком Game Mode -->
        <!-- 🔴 ЧИСЛО ИДУЩИХ ПАРТИЙ ПИШЕМ ПРЯМО НА ГЛАЗИКЕ (просьба оунера 2026-08-31). Раньше кнопка
             ничего не обещала: игрок нажимал и половину времени видел «активных партий нет». Число
             приходит тем же ответом `/lobby_counts`, что и счётчики фракций, — отдельного опроса нет.
             Пока ответа нет, место под число занято невидимым каркасом (экран не дёргается). -->
        <button class="pvp__watch" type="button" :title="$t('pvp.watchActive')" @click="openWatch">
          <span class="pvp__watch-ico">👁</span>
          <span class="pvp__watch-num" :class="{ 'pvp__watch-num--pending': liveCount === null }">{{ liveCount || 0 }}</span>
        </button>
      </div>
      <div class="pvp__choosers">
        <input type="radio" v-model="fraction" value="Zombie" id="race-zombie" :disabled="tutFractionLock === 'Elf'">
        <label class="pvp__radio" :class="{ 'pvp__radio--locked': tutFractionLock === 'Elf' }" for="race-zombie">
          <img :src="zombie" alt="" width="32" height="32">
          {{ $t('unit.Zombie') }}<span class="pvp__wait" :class="{ 'pvp__wait--pending': lobbyCount('Zombie') === null }"> ({{ lobbyCount('Zombie') || 0 }})</span>
        </label>
        <input type="radio" v-model="mode" value="KillKingTimer" id="mode-kiktime">
        <label class="pvp__radio" for="mode-kiktime">
          {{ $t('pvp.modeKillKingTimer') }}
        </label>
        <input type="radio" v-model="fraction" value="Elf" id="race-elf" :disabled="tutFractionLock === 'Zombie'">
        <label class="pvp__radio" :class="{ 'pvp__radio--locked': tutFractionLock === 'Zombie' }" for="race-elf">
          <img :src="elf" alt="" width="32" height="32">
          {{ $t('unit.Elf') }}<span class="pvp__wait" :class="{ 'pvp__wait--pending': lobbyCount('Elf') === null }"> ({{ lobbyCount('Elf') || 0 }})</span>
        </label>
      </div>
    <!-- Обучение: первая партия — только за свою сторону, на её фигурах надет дар наставника -->
    <div v-if="tutFractionLock" class="pvp__tutlock">🔒 {{ $tut('tut.pvpLock', { side: $t(tutFractionLock === 'Elf' ? 'unit.ElfGen' : 'unit.ZombieGen') }) }}</div>
    <!-- ПК: сила выровнена под кнопками фракций (Zombie слева / Elf справа).
         🔴 Блок ДЕРЖИТ своё место с первого кадра (невидимый каркас, пока `/army_power` в пути):
         иначе его приход сдвигал вниз ползунок допуска, «В бой» и таблицу лидеров — экран прыгал
         (жалоба оунера 2026-08-30). Запрос упал → каркас убираем, пустой полосы не остаётся. -->
    <div v-if="myPower || powerPending" class="pvp__powers pvp__powers--desktop" :class="{ 'pvp__powers--pending': !myPower }">
      <div class="pvp__power-col">
        <div v-if="fraction === 'Zombie'">{{ $t('pvp.yourPower') }}: {{ Math.round(powerBox.Zombie) }}</div>
        <div v-else class="pvp__power-opp">{{ $t('pvp.oppPower') }}: {{ oppRange.lo }}–{{ oppRange.hi }}</div>
      </div>
      <div class="pvp__power-col pvp__power-col--right">
        <div v-if="fraction === 'Elf'">{{ $t('pvp.yourPower') }}: {{ Math.round(powerBox.Elf) }}</div>
        <div v-else class="pvp__power-opp">{{ $t('pvp.oppPower') }}: {{ oppRange.lo }}–{{ oppRange.hi }}</div>
      </div>
    </div>
    <!-- Мобилка: ВСЕГДА своя сила слева, соперник справа (не перепрыгивает при смене фракции) -->
    <div v-if="myPower || powerPending" class="pvp__powers pvp__powers--mobile" :class="{ 'pvp__powers--pending': !myPower }">
      <div class="pvp__power-col">{{ $t('pvp.yourPower') }}: {{ Math.round(powerBox[fraction]) }}</div>
      <div class="pvp__power-col pvp__power-col--right pvp__power-opp">{{ $t('pvp.oppPower') }}: {{ oppRange.lo }}–{{ oppRange.hi }}</div>
    </div>
    <div class="pvp__dev">
      <div class="pvp__dev-label">{{ $t('pvp.deviation') }}: ±{{ Math.round(powerDeviation * 100) }}%</div>
      <input
        class="pvp__dev-slider"
        type="range"
        min="0"
        :max="DEV_STEPS.length - 1"
        step="1"
        :value="devIndex"
        @input="onDevSlide"
      >
    </div>
    <!-- Сезон (Турнир): играют только друг с другом, бот-подсадка бэком отключена — не показываем.
         🔴 Настройки бота СВЁРНУТЫ (просьба оунера 2026-08-20): три блока с подсказками занимали
         пол-экрана и отодвигали «В бой» и таблицу лидеров вниз. В свёрнутой строке видно главное —
         включён ли бот и на какой сложности, — поэтому состояние читается без раскрытия. -->
    <div v-if="!inSeason" class="pvp__botbox" :class="{ 'pvp__botbox--open': botBoxOpen }">
      <button class="pvp__botbox-head" type="button" :aria-expanded="botBoxOpen ? 'true' : 'false'" @click="botBoxOpen = !botBoxOpen">
        <span class="pvp__botbox-title">{{ $t('pvp.allowBot') }}</span>
        <span class="pvp__botbox-state">{{ botSummary }}</span>
        <span class="pvp__botbox-chevron">{{ botBoxOpen ? '▲' : '▼' }}</span>
      </button>
      <div v-if="botBoxOpen" class="pvp__botbox-body">
        <label class="pvp__bot">
          <input type="checkbox" v-model="allowBot">
          <span class="pvp__bot-text">
            {{ $t('pvp.allowBot') }}
            <small>{{ $t('pvp.allowBotHint') }}</small>
          </span>
        </label>
        <label v-if="allowBot" class="pvp__bot">
          <input type="checkbox" v-model="botSurrender">
          <span class="pvp__bot-text">
            {{ $t('pvp.botSurrender') }}
            <small>{{ $t('pvp.botSurrenderHint') }}</small>
          </span>
        </label>
        <!-- СЛОЖНОСТЬ подсадного бота — ПОЛЗУНОК 0..7: Лёгкий (без карты силы, ничего не приносит) / Средний
             (карта силы + дроп амуниции/ресурсов) / Сложный и выше (поисковый мозг: бот просчитывает партию на
             столько ходов вперёд, каков уровень; награды как у Сложного). Рейтинг не растёт ни с одним из
             уровней. В первой партии обучения ползунок заблокирован на «Лёгком». -->
        <div v-if="allowBot" class="pvp__bot pvp__bot--diff">
          <span class="pvp__bot-text">
            {{ $t('pvp.botDifficulty') }}: <b>{{ botLevelName }}</b>
            <small>{{ botLevelHint }}</small>
          </span>
          <input
            class="pvp__diff-slider"
            type="range"
            min="0"
            max="2"
            step="1"
            :value="botLevel"
            :disabled="tutFractionLock"
            @input="onDiffSlide"
          >
          <div class="pvp__diff-ticks">
            <span
              v-for="(name, i) in botLevelNames"
              :key="name"
              :class="{ 'pvp__diff-tick--on': botLevel === i }"
            >{{ name }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Активная партия за ВЫБРАННУЮ фракцию → сдаться / вернуться (вместо Старта) -->
    <div v-if="activeInFraction" class="pvp__match-actions">
      <button class="pvp-start btn btn-submit pvp-start--surrender" @click="surrenderMatch">{{ $t('pvp.surrender') }}</button>
      <button class="pvp-start btn btn-submit" @click="returnToMatch">{{ $t('pvp.returnToMatch') }}</button>
    </div>
    <!-- Партия завершена, но фигуры выбранной фракции ещё не восстановлены → настройки фигур -->
    <button v-else-if="fractionLocked" class="pvp-start btn btn-submit" data-tut="figures" @click="goToPack">
      {{ $t('pvp.figures') }}
    </button>
    <!-- Турнир ещё не идёт: играть нельзя (регистрация/пауза) -->
    <button v-else-if="seasonWaiting" class="pvp-start btn btn-submit" disabled>
      {{ $t('pvp.tourNotStarted') }}
    </button>
    <!-- Обычный старт: фракция не в партии и фигуры восстановлены -->
    <button v-else class="pvp-start btn btn-submit" @click="startMatch">
      {{ $t('pvp.start') }}
    </button>
    <!-- 🔴 ПЕРЕХОД В «НАСТРОЙКИ ФИГУР» ПРЯМО ПОД «В БОЙ» (просьба оунера 2026-09-11). Отсюда игрок
         уходит чинить и переодевать армию чаще всего, а путь был только через профиль — два экрана
         в обход. 🔴 НО НЕ ДВАЖДЫ (аудит 2026-09-13): в ветке `fractionLocked` та же кнопка уже
         стоит ВМЕСТО «В бой», и вторичная давала второй экземпляр с тем же текстом друг под другом —
         игрок читает это как «одна из них другая». -->
    <button v-if="!fractionLocked" class="pvp-start pvp-start--pack btn btn-submit" @click="goToPack">
      {{ $t('pvp.figures') }}
    </button>
    <!-- 🔴 СЛЕД ПОКУПКИ ЗА ЗВЁЗДЫ (просьба оунера 2026-09-15). Покупка с сайта оплачивается в ДРУГОМ
         приложении, и вернуться игрок может куда угодно — чаще всего именно сюда, в лобби. Строка
         говорит, что операция ещё идёт, поздравляет с выдачей и честно сообщает, если оплата не
         прошла. Заявки нет — блока нет вовсе (он читается из localStorage СИНХРОННО, поэтому
         появление строки не двигает карточку лобби после первого кадра). -->
    <StarsOrderLine />
    <!-- Виджет заданий дня: прогресс к сундуку прямо там, где игрок жмёт «Старт» (docs/daily/) -->
    <!-- 🔴 Пока ответ `/daily` в пути, виджет ДЕРЖИТ своё место (невидимый каркас): иначе его приход
         сдвигал таблицу лидеров вниз — «интерфейс скачет» (фидбек оунера 2026-08-10). -->
    <router-link
      v-if="dailyWidget || dailyPending" to="/daily"
      class="pvp__daily" :class="{ 'pvp__daily--pending': !dailyWidget }"
    >
      <span class="pvp__daily-ico">🗓️</span>
      <span class="pvp__daily-body">
        <span class="pvp__daily-top">
          <span class="pvp__daily-title">{{ $t('daily.title') }}</span>
          <span class="pvp__daily-pts">{{ dailyBox.points }} / {{ dailyBox.threshold }}</span>
        </span>
        <span class="pvp__daily-bar"><i :style="{ width: dailyBox.pct + '%' }"></i></span>
        <span class="pvp__daily-note">{{ dailyBox.note }}</span>
      </span>
      <span v-if="dailyBadge" class="pvp__daily-badge">{{ dailyBadge }}</span>
    </router-link>

    <LeaderBoard />

    <!-- Режим наблюдателя: список активных партий (клик → смотреть) -->
    <div v-if="surrenderAsk" class="watch-modal" @click.self="surrenderAsk = false">
      <div class="watch-modal__box">
        <div class="watch-modal__head">
          <span>{{ $t('pvp.surrender') }}</span>
          <button class="watch-modal__close" type="button" @click="surrenderAsk = false">✕</button>
        </div>
        <div class="watch-modal__empty">{{ $t('pvp.surrenderConfirm') }}</div>
        <div class="watch-modal__acts">
          <button type="button" @click="confirmSurrender">{{ $t('pvp.surrender') }}</button>
          <button type="button" @click="surrenderAsk = false">{{ $t('common.cancel') }}</button>
        </div>
      </div>
    </div>

    <div v-if="watchOpen" class="watch-modal" @click.self="closeWatch">
      <div class="watch-modal__box">
        <div class="watch-modal__head">
          <span>{{ $t('pvp.activeMatches') }}</span>
          <button class="watch-modal__close" type="button" @click="closeWatch">✕</button>
        </div>
        <div v-if="liveLoading" class="watch-modal__empty">{{ $t('common.loading') }}</div>
        <div v-else-if="!liveMatches.length" class="watch-modal__empty">{{ $t('pvp.noActive') }}</div>
        <ul v-else class="watch-modal__list">
          <li v-for="m in liveMatches" :key="m.match_id" class="watch-row" @click="spectate(m)">
            <div class="watch-row__side">
              <img :src="elf" width="22" height="22" alt="">
              <span class="watch-row__name">{{ m.elf.username }}</span>
              <span class="watch-row__pow">{{ Math.round(m.elf.power) }}</span>
            </div>
            <div class="watch-row__vs">
              <span v-if="m.in_fight" class="watch-row__fight" :title="$t('pvp.fightInProgress')">⚔</span>
              <span v-else>vs</span>
            </div>
            <div class="watch-row__side watch-row__side--right">
              <span class="watch-row__pow">{{ Math.round(m.zombie.power) }}</span>
              <span class="watch-row__name">{{ m.zombie.username }}</span>
              <img :src="zombie" width="22" height="22" alt="">
            </div>
            <div class="watch-row__meta">
              <span :title="$t('pvp.viewers')">👁 {{ m.spectators }}</span>
              <span :title="$t('pvp.likes')">❤ {{ m.likes }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- ОБУЧЕНИЕ: разовый обзор лобби при ПЕРВОМ заходе — допуск по силе, таблица лидеров,
         режим наблюдателя. Не шаг цепочки: партия запускается отсюда, объясняем сразу. -->
    <TutorialSpotlight
      v-if="tutComp"
      :target="tutComp.target"
      :title="$tut(tutComp.title)"
      :text="$tut(tutComp.text)"
      :counter="tutStopCounter"
      :next-label="$tut('tut.next')"
      :mentor-icon="tutMentorIcon"
      :portrait="tutPortrait"
      @next="tutCompNext"
      @skip="tutSkip"
    />
    <!-- 🔴 ПОСЛЕ ОБЗОРА ЛОББИ НАСТАВНИК ВЕДЁТ В ПЕРВУЮ ПАРТИЮ (жалоба оунера 2026-08-31: «после
         рассказа про глазик обучение прерывается»). Обзор — не шаг цепочки: он гаснет, и на `/pvp`
         показывать было НЕЧЕГО (ни один шаг `STEPS` не живёт на этом экране), а следующий шаг
         `match_wait` ждёт игрока уже НА ЭКРАНЕ ПАРТИИ — то есть после того, как он сам догадается
         нажать «В бой». Подсвечиваем кнопку, пока шаг ждёт игрока где угодно (`tutorialPending`). -->
    <TutorialSpotlight
      v-if="tutToBattle"
      target=".pvp-start"
      :title="$tut('tut.pvpToBattleTitle')"
      :text="$tut('tut.pvpToBattle')"
      :next-label="$tut('tut.gotIt')"
      :mentor-icon="tutMentorIcon"
      :portrait="tutPortrait"
      @next="tutHideBattle = true"
      @skip="tutSkip"
    />
    <!-- 🔴 ПОДХВАТ ПОСЛЕ ПЕРВОЙ ПАРТИИ (оунер 2026-07-31): первая обучающая партия не даёт наград дня
         (лёгкий бот), игрок возвращается сюда, а не в /daily → цепочка рвалась на шаге daily_after.
         Ведём его в «Настройки фигур» (кнопка активна: армия ранена), там обучение продолжится с лечения. -->
    <TutorialSpotlight
      v-if="tutFigures"
      target="[data-tut='figures']"
      :title="$tut('tut.pvpToPackTitle')"
      :text="$tut('tut.pvpToPack')"
      :next-label="$tut('tut.toPack')"
      :mentor-icon="tutMentorIcon"
      :portrait="tutPortrait"
      @next="goToPack"
      @skip="tutSkip"
    />
  </div>
</template>

<script>
import TutorialHelp from '@/components/tutorial/TutorialHelp';
import { mapGetters } from 'vuex';

import Unity from "@/./unity.js"
import LeaderBoard from "@/components/LeaderBoard.vue";
import StarsOrderLine from '@/components/StarsOrderLine';
import TutorialSpotlight from '@/components/tutorial/TutorialSpotlight';
import { mentorIcon, mentorPortrait } from '@/components/tutorial/mentor';
import { waitReward } from '@/components/tutorial/flow';
import zombie from "../assets/zombie.webp"
import elf from "../assets/elf.webp"

// 🔴 ОБЗОР ЛОББИ — РАЗОВЫЙ, ПРИ ПЕРВОМ ЗАХОДЕ (решение оунера 2026-07-30). Раньше эти три остановки
// были шагами Акта 4, а он ждёт ТРЁХ ПОБЕД НАД ЖИВЫМИ игроками — тестируя с ботом, их не видно
// вообще. Каждая партия запускается отсюда, поэтому раздел объясняем сразу: сервер держит обзор в
// `tours` (`SEEN_TOURS["pvp"]`), клиент проходит остановки подряд и в конце шлёт `tutorialSeen`.
const PVP_TOUR = 'pvp';
const PVP_STOPS = [
  { target: '.pvp__dev', title: 'tut.compDevTitle', text: 'tut.compDev' },
  { target: '.lb', title: 'tut.compBoardTitle', text: 'tut.compBoard' },
  { target: '.pvp__watch', title: 'tut.compSpectateTitle', text: 'tut.compSpectate' },
];

export default {
  name: "PagePVP",
  data: function () {
    return {
      zombie: zombie,
      elf: elf,
      tutStopIdx: 0,   // остановка разового обзора лобби (0..2), см. PVP_STOPS
      tutHideBattle: false,  // «Понятно» на подсказке «нажми В бой» — прячем её до следующего захода
      // Дискретные шаги допуска отклонения силы соперника: ±5..±50%. Значения = доля (0.05..0.5).
      DEV_STEPS: [0.05, 0.1, 0.2, 0.3, 0.4, 0.5],
      myPower: null,       // {Elf, Zombie} — совокупная сила армии игрока по фракциям (для подписей)
      powerPending: true,  // ответ `/army_power` ещё в пути → блок силы держит место невидимым каркасом
      fractionReady: null,
      activeMatch: null,   // {match_id, fraction} активной партии игрока или null (для кнопок Сдаться/Вернуться)
      lobbyCounts: null,   // {Elf, Zombie} — сколько ждут пару за фракцию (для «(N)» рядом с фракцией)
      lobbyTimer: null,
      // Настройки соперника-бота свёрнуты. Открыты сразу, если бот уже включён: игрок,
      // который им пользуется, не должен каждый раз раскрывать блок ради сложности.
      botBoxOpen: false,
      watchOpen: false,    // открыт список активных партий (режим наблюдателя)
      surrenderAsk: false, // окно подтверждения сдачи (своё, не системное)
      liveMatches: [],     // активные партии из /matches/live
      liveLoading: false
    }
  },
  async mounted() {
    this.botBoxOpen = !!this.allowBot   // бот включён → настройки сразу на виду
    if (this.inSeason) this.$store.dispatch('REFRESH_SEASON_STATE', this) // актуальный статус турнира → гейт «Start»
    await this.fetchRecovery()
    this.fetchArmyPower()
    this.fetchActiveMatch()
    this.fetchLobbyCounts()
    this.lobbyTimer = setInterval(() => { this.fetchLobbyCounts(); this.fetchActiveMatch() }, 5000)  // опрос лобби + активной партии
    if (process.env.VUE_APP_ENABLE_WEB_CLIENT === 'true') {
      this.$store.dispatch('fetchDaily')       // виджет заданий дня
      // обучение: гейт фракции на первую партию + подсадка бота включена по умолчанию
      // (первую партию новичок обязан сыграть и выиграть — ждать живого соперника незачем)
      await this.$store.dispatch('fetchTutorial')
      // 🔴 СТОРОНУ ДОСПРАШИВАЕМ, ЕСЛИ ЕЁ ЕЩЁ НЕТ. Гейт первой партии (своя фракция + подсадной бот)
      // держится на `configLoaded`; пока он false, гейт возвращает null и новичок может уйти в
      // очередь к ЖИВОМУ сопернику. Тот же приём уже стоит в «Настройках фигур» (PagePack).
      if (this.$store.getters.tutorialActive && !this.$store.state.pvp.configLoaded) {
        await this.$store.dispatch('TRY_AUTH', this).catch(() => {})
      }
      if (this.tutFractionLock && !this.allowBot) this.allowBot = true
    }
  },
  beforeUnmount() {
    if (this.lobbyTimer) clearInterval(this.lobbyTimer)
  },
  components: { TutorialHelp,LeaderBoard, TutorialSpotlight, StarsOrderLine},
  computed: {
    // ОБУЧЕНИЕ: разовый обзор лобби. Показываем, пока сервер держит его в `tours` (до первого
    // просмотра); отказавшимся от обучения и старым игрокам сервер обзор не присылает.
    tutComp() {
      if (this.$store.getters.tutorialBusy) return null;
      if (!this.$store.getters.tutorialTours.includes(PVP_TOUR)) return null;
      return PVP_STOPS[this.tutStopIdx] || null;
    },
    // подпись «остановка N из 3» на карточке наставника
    tutStopCounter() {
      return this.$tut('tut.stopOf', { n: this.tutStopIdx + 1, total: PVP_STOPS.length });
    },
    tutStopLast() { return this.tutStopIdx + 1 >= PVP_STOPS.length; },
    // ОБУЧЕНИЕ: подхват на шаге `daily_after` в лобби (первая партия не дала наград дня — игрок вернулся
    // сюда). Подсвечиваем кнопку «Настройки фигур»; сам шаг проматывает /pack при заходе (см. PagePack).
    tutFigures() {
      if (this.tutComp || this.$store.getters.tutorialBusy) return null;
      if (!this.$store.getters.tutorialActive) return null;
      // 🔴 `tutorialPending`, а не `tutorialStep`: шаг живёт на `/daily`, а подсветку рисует лобби —
      // шаг ТЕКУЩЕГО экрана здесь всегда null (модель «что пройдено», 2026-08-20).
      if (!this.$store.getters.tutorialPending('daily_after')) return null;
      return this.fractionLocked; // кнопка есть только когда армия не восстановлена
    },
    // ОБУЧЕНИЕ: «нажми В бой» — мостик между обзором лобби и первой партией. Условия:
    // обзор закрыт, обучение идёт, первая победа ещё не взята, шаг ожидания партии ещё ждёт игрока,
    // партия сейчас не идёт (иначе подсказка висела бы поверх кнопок «Сдаться»/«Вернуться»),
    // и фигуры целы — с ранеными кнопки «В бой» на экране нет вовсе.
    tutToBattle() {
      if (this.tutHideBattle || this.tutComp || this.$store.getters.tutorialBusy) return false;
      if (!this.$store.getters.tutorialActive) return false;
      if (this.$store.getters.tutorialActDone('act1')) return false;
      if (!this.$store.getters.tutorialPending('match_wait')) return false;
      return !this.activeInFraction && !this.fractionLocked && !this.seasonWaiting;
    },
    tutPortrait() { return mentorPortrait(this.$store.state.pvp.fraction); },
    tutMentorIcon() { return mentorIcon(this.$store.state.pvp.fraction); },
    ...mapGetters(['dailyBadge']),
    // ОБУЧЕНИЕ: до конца первой партии играем ТОЛЬКО за свою сторону — на её фигурах дар наставника
    // (решение оунера 2026-07-29). Возвращает код фракции игрока или null, если ограничения нет.
    // 🔴 Гейт держится ПО АКТУ, а не по списку кодов шагов: перечисление устаревало при каждой
    // вставке шага, и на новых шагах фракция снова разблокировалась, а бот не включался
    // (фидбек оунера 2026-07-29). Первую партию новичок играет своей стороной — на её фигурах дар.
    tutFractionLock() {
      if (!this.$store.getters.tutorialActive) return null;
      if (this.$store.getters.tutorialActDone('act1')) return null;   // первая победа уже есть
      if (!this.$store.state.pvp.configLoaded) return null;           // сторона ещё не подтверждена
      return this.$store.state.pvp.fraction === 'Zombie' ? 'Zombie' : 'Elf';
    },
    // Виджет заданий дня в лобби: null, пока состояние не загружено (веб-клиент/вне турнира).
    dailyWidget() {
      const d = this.$store.state.daily.data;
      if (!d) return null;
      const left = Math.max(0, d.threshold - d.points);
      const ready = (d.quests || []).filter((q) => q.ready).length;
      return {
        points: d.points,
        threshold: d.threshold,
        pct: Math.max(0, Math.min(100, Math.round((d.points / (d.threshold || 1)) * 100))),
        note: ready
          ? this.$t('daily.claimAll', { n: ready })
          // routesLeft/routesDone заканчиваются двоеточием (в разделе за ними идёт список
          // маршрутов) — в виджете нужна САМОСТОЯТЕЛЬНАЯ фраза, иначе строка обрывается на «:».
          : (left > 0 ? this.$t('daily.leftShort', { n: left }) : this.$t('daily.chestOpen')),
      };
    },
    // Число идущих партий для глазика: приходит полем `live` в ответе `/lobby_counts`. Старый бэк
    // поля не шлёт — тогда null, и на кнопке остаётся каркас вместо числа (врать нулём нельзя).
    liveCount() {
      const v = this.lobbyCounts ? this.lobbyCounts.live : null;
      return v == null ? null : v;
    },
    // Значения силы с фолбэком для каркаса (он невидим, `visibility: hidden`).
    // 🔴 ЧЕТЫРЁХЗНАЧНЫЕ ЗАГЛУШКИ, А НЕ НУЛИ: на телефоне подпись «Сила соперника: 1188–1312»
    // переносится на ВТОРУЮ строку, а «0–0» влезает в одну — каркас был на 18 px ниже настоящего
    // блока, и лобби всё равно дёргалось, когда приходил ответ (поймано `tools/jump-audit.mjs`).
    // Числа тут ничего не значат: их никто не видит, важна только длина строки.
    powerBox() { return this.myPower || { Elf: 8888, Zombie: 8888 }; },
    // Ответ `/daily` ещё в пути (данных нет, ошибки тоже) — держим место виджета невидимым каркасом.
    // Запрос упал → каркас не показываем вовсе, иначе в лобби навсегда осталась бы пустая полоса.
    dailyPending() { return !this.$store.state.daily.data && !this.$store.state.daily.error; },
    // Значения виджета с фолбэком: до ответа рисуем пустой каркас, а не падаем на чтении полей.
    // 🔴 note — неразрывный пробел, а не пустая строка: пустой span имеет НУЛЕВУЮ высоту, каркас
    // выходил на 19px ниже настоящего виджета, и лобби (оно центрируется) всё равно дёргалось.
    dailyBox() { return this.dailyWidget || { points: 0, threshold: 100, pct: 0, note: ' ' }; },
    // Сезон (Турнир): активная сезонная сессия — бот-подсадка на бэке отключена сабам, чекбокс скрываем.
    inSeason() { return this.$store.state.season.active; },
    // В турнирном аккаунте играть можно только когда турнир идёт (active). До старта — «Start» заблокирован.
    seasonWaiting() { return this.inSeason && this.$store.state.season.seasonState !== 'active'; },
    // гейт лечения/оживления: армия выбранной фракции не восстановлена → вместо старта «Настройки фигур»
    fractionLocked() {
      return !!(this.fractionReady && this.fractionReady[this.fraction] === false)
    },
    // ВЫБРАННАЯ фракция сейчас в активной партии игрока → показываем «Сдаться»/«Вернуться в партию»
    activeInFraction() {
      return !!(this.activeMatch && this.activeMatch.match_id && this.activeMatch.fraction === this.fraction)
    },
    fraction: {
      get () {
        return this.$store.state.pvp.fraction
      },
      set (value) {
        this.$store.commit('SET_FRACTION', value)
      }
    },
    mode: {
      get () {
        return this.$store.state.pvp.mode
      },
      set (value) {
        this.$store.commit('SET_MODE', value)
      }
    },
    allowBot: {
      get () {
        return this.$store.state.pvp.allowBot
      },
      set (value) {
        this.$store.commit('SET_ALLOW_BOT', value)
      }
    },
    botSurrender: {
      get () {
        return this.$store.state.pvp.botSurrender
      },
      set (value) {
        this.$store.commit('SET_BOT_SURRENDER', value)
      }
    },
    // Уровень сложности бота (0..2). В первой партии обучения выбор заблокирован: наставник обязан быть лёгким.
    botLevel () {
      return this.tutFractionLock ? 0 : this.$store.state.pvp.botLevel
    },
    // ТРИ уровня (решение оунера 2026-08-07, было восемь): лёгкий — без карты сил, средний — только
    // карта, сложный — поисковый мозг (прежняя «Легенда»). Имена стоят подписями у тиков ползунка.
    botLevelNames () {
      return [this.$t('pvp.botEasy'), this.$t('pvp.botMedium'), this.$t('pvp.botHard')]
    },
    botLevelName () {
      return this.botLevelNames[this.botLevel] || this.botLevelNames[0]
    },
    botLevelHint () {
      const hints = [this.$t('pvp.botEasyHint'), this.$t('pvp.botMediumHint'), this.$t('pvp.botHardHint')]
      return hints[this.botLevel] || hints[0]
    },
    // Строка в СВЁРНУТОЙ шапке настроек бота: включён ли он и на какой сложности. Без неё игрок
    // не видел бы главного, не раскрывая блок, — а от этого зависит, с кем он сейчас начнёт партию.
    botSummary () {
      return this.allowBot ? `${this.$t('common.on')} · ${this.botLevelName}` : this.$t('common.off')
    },
    powerDeviation () {
      return this.$store.state.pvp.powerDeviation
    },
    devIndex () {
      const i = this.DEV_STEPS.indexOf(this.powerDeviation)
      return i === -1 ? 0 : i  // дефолт ±5% (первая ступень)
    },
    // Диапазон силы соперника = сила ВЫБРАННОЙ фракции игрока ± допуск (односторонний, как на бэке)
    oppRange () {
      const p = this.powerBox[this.fraction] || 0
      return {
        lo: Math.round(p * (1 - this.powerDeviation)),
        hi: Math.round(p * (1 + this.powerDeviation))
      }
    },
    // hints: {
    //   get () {
    //     return this.$store.state.pvp.hints
    //   },
    //   set (value) {
    //     this.$store.commit('SET_HINTS', value)
    //   }
    // },
  },
  watch: {
    // обучение и конфиг приходят с сервера ПОЗЖЕ монтирования: включаем подсадку бота тогда же,
    // когда становится известен гейт (иначе новичок ждал живого соперника и не мог начать)
    tutFractionLock(lock) { if (lock && !this.allowBot) this.allowBot = true },
    powerDeviation() { this.fetchLobbyCounts() },  // счётчик сразу под новый допуск
  },
  methods: {
    // остановка обзора пройдена; на последней помечаем обзор просмотренным (второй раз не покажем)
    async tutCompNext() {
      if (!this.tutComp) return;
      if (!this.tutStopLast) { this.tutStopIdx += 1; return; }
      // 🔴 Счётчик НЕ сбрасываем: до ответа сервера обзор снова показал бы остановку 1 (тот же
      // дефект, что на рынке — жалоба оунера 2026-08-30). Гасит его локальная отметка в сторе.
      await this.$store.dispatch('tutorialSeen', PVP_TOUR);
    },
    tutSkip() { this.$store.dispatch('tutorialSkip'); },
    async fetchRecovery() {
      try {
        const r = await this.axios.get('/units/recovery')
        this.fractionReady = r.data.fraction_ready || null
      } catch (e) { this.fractionReady = null }
    },
    async fetchActiveMatch() {
      try {
        const r = await this.axios.get('/matches/active')
        this.activeMatch = (r.data && r.data.match_id) ? r.data : null
      } catch (e) { this.activeMatch = null }
    },
    returnToMatch() { this.$router.push('/play-web') },
    // 🔴 ПЕРЕХОД ПО ПОДСКАЗКЕ ЗАКРЫВАЕТ ЕЁ ШАГ (жалоба оунера 2026-08-31: «после первой партии
    // "Задания дня" снова просят забрать награду и уйти в Настройки фигур, а там ничего нет»).
    // Шаг `daily_after` живёт на `/daily`, но увести в «Настройки фигур» может и лобби — а отметку
    // ставил только экран заданий. Игрок шёл коротким путём (лобби → Настройки фигур), проходил
    // весь блок армии, и шаг ЖДАЛ его в заданиях как непройденный: окно всплывало второй раз, а
    // переход по нему уже ничего не открывал. Заодно это разблокирует Акт 2 (без его закрытия не
    // выдаётся награда акта, а Акт 3 наоборот приезжает в тот же день — гейт «новый день» пуст).
    async goToPack() {
      if (this.$store.getters.tutorialPending('daily_after')) {
        await this.$store.dispatch('tutorialStepDone', 'daily_after');
        await waitReward(this.$store);   // окно награды закрывает игрок, только потом уводим дальше
      }
      this.$router.push('/pack');
    },
    async openWatch() {
      this.watchOpen = true
      this.liveLoading = true
      try {
        const r = await this.axios.get('/matches/live')
        this.liveMatches = Array.isArray(r.data) ? r.data : []
      } catch (e) { this.liveMatches = [] }
      this.liveLoading = false
    },
    closeWatch() { this.watchOpen = false },
    // открыть партию в режиме зрителя: /play-web?spectate=<match_id> → PagePlayWeb войдёт наблюдателем
    spectate(m) { this.$router.push({ path: '/play-web', query: { spectate: m.match_id } }) },
    async surrenderMatch() {
      // 🔴 СВОИМ ОКНОМ, А НЕ `window.confirm` (правило оунера 2026-08-31, оно на всю игру).
      const m = this.activeMatch
      if (!m || !m.match_id) return
      this.surrenderAsk = true
    },
    async confirmSurrender() {
      this.surrenderAsk = false
      const m = this.activeMatch
      if (!m || !m.match_id) return
      try {
        await this.axios.post(`/matches/${m.match_id}/surrender`)
      } catch (e) { /* уже завершён/не найден — просто обновим состояние ниже */ }
      await this.fetchActiveMatch()
      await this.fetchRecovery()
    },
    async fetchArmyPower() {
      try {
        const r = await this.axios.get('/army_power')
        this.myPower = r.data || null
      } catch (e) { this.myPower = null } finally { this.powerPending = false }
    },
    async fetchLobbyCounts() {
      try {
        // tol = живой допуск ползунка → счётчик показывает только совместимых по силе соперников
        const r = await this.axios.get('/lobby_counts', { params: { tol: this.powerDeviation } })
        this.lobbyCounts = r.data || null
      } catch (e) { this.lobbyCounts = null }
    },
    // сколько партий идёт прямо сейчас (число на глазике); null — ответа ещё нет
    lobbyCount(fr) {
      return this.lobbyCounts ? (this.lobbyCounts[fr] || 0) : null
    },
    onDevSlide(e) {
      const idx = Math.min(this.DEV_STEPS.length - 1, Math.max(0, parseInt(e.target.value, 10)))
      this.$store.commit('SET_POWER_DEVIATION', this.DEV_STEPS[idx])
    },
    onDiffSlide(e) {
      if (this.tutFractionLock) return  // в обучении наставник заблокирован на «Лёгком»
      this.$store.commit('SET_BOT_LEVEL', parseInt(e.target.value, 10))
    },
    async startMatch(){
      // В турнирном аккаунте старт разрешён только когда турнир идёт (бэк отклонит матчмейкинг чужого пула,
      // но не пускаем и на клиенте — чтобы не висеть в лобби до старта).
      if (this.seasonWaiting) return
      // кнопка Start видна только когда фракция восстановлена и не в партии; на всякий случай сверимся с
      // сервером (он тоже гейтит) — если фигуры вдруг не готовы, тихо переоценим состояние без старта
      await this.fetchRecovery()
      if (this.fractionLocked) return
      // 🔴 СТРАХОВКА ПЕРВОЙ ПАРТИИ. Если обучение идёт, Акт 1 не закрыт, а сторона так и не
      // подтвердилась (сервер не ответил, вкладка пережила выкат), гейт `tutFractionLock` молчит —
      // и новичок уходит искать ЖИВОГО соперника. В сомнении включаем подсадного бота: лишний бот
      // в первой партии безвреден, проигрыш живому сопернику в ней — нет.
      if (this.$store.getters.tutorialActive && !this.$store.getters.tutorialActDone('act1') && !this.allowBot) {
        this.allowBot = true
      }
      await this.$store.dispatch('SAVE_CONFIG', this)
      // Новый веб-клиент: переходим на игровой экран, там идёт матчмейкинг на сервере.
      if (process.env.VUE_APP_ENABLE_WEB_CLIENT === 'true') {
        this.$router.push('/play-web')
        return
      }
      // Старый путь через Unity (если веб-клиент выключен).
      this.$store.dispatch('SET_STATUS', 'play')
      let payload = {
        'token': this.$store.state.auth.jwt,
        'fraction': this.$store.state.pvp.fraction,
        'mode': this.$store.state.pvp.mode,
        'backendUrl': process.env.VUE_APP_BASE_URL
        // 'hints': this.$store.state.pvp.hints,
      }
      console.debug("call Unity.send('GameManager', 'SetToken'" + JSON.stringify(payload))
      Unity.send('GameManager', 'SetToken', JSON.stringify(payload))
      Unity.on('created', () => {
        Unity.send('GameManager', 'SetToken', JSON.stringify(payload))
    })
    }
  }
}

</script>

<style scoped lang="scss">
  // Корень страницы PvP — точка отсчёта для глазика. ПК: свой паддинг рамки (перебивает App padding:50px).
  // 🔴 ПОТОЛОК ШИРИНЫ (жалоба оунера 2026-08-19): карточка тянулась во всю ширину окна — на ПК и в
  // мини-аппе, открытом на весь экран, «Ваша сила» и «Сила соперника» разъезжались к противоположным
  // краям (на 1920 между ними полтора экрана), узорная рамка растягивалась, а таблица лидеров давала
  // колонкам по 270px пустоты. 1100px — та же мера, что у игрового поля (`.chess`), интерфейс
  // остаётся одной колонкой по центру на любом мониторе.
  .card-landscape{ position: relative; padding: 20px; width: 100%; max-width: 1100px; margin: 0 auto; box-sizing: border-box; }
  .pvp{
    display: grid;
    grid-template-columns: repeat(3, auto);
    text-transform: uppercase;
    grid-gap: 2em;
    &-start{
      grid-column-start: 2;
    }
    &__header{
      background: url("../assets/category.webp") no-repeat;
      background-size: 100% 100%;
      font-size: 18px;
      // 🔴 Шапка ужата (просьба оунера 2026-08-20): было `padding: 16px 32px; margin: 40px auto 32px`,
      // и заголовок с воздухом вокруг съедал четверть высоты карточки — «В бой» и таблица лидеров
      // уходили вниз. Табличка-спрайт остаётся читаемой, но перестаёт быть главным блоком экрана.
      padding: 10px 32px;
      color: yellow;
      width: 34%;
      margin: 14px auto 18px;
      text-align: center;
      box-sizing: border-box;
      &s{
        display: flex;
        justify-content: center;
        position: relative;
      }
    }
    &__watch{
      // Внутри .pvp__headers (position:relative). ПК: отступ сверху/справа в px (значения тюнера).
      // top уменьшен вместе с отступом шапки — глазик остаётся на одной линии с заголовком.
      position: absolute;
      right: 27px;
      top: 6px;
      transform: none;
      z-index: 10;
      width: 52px;
      height: 52px;
      border: 1px solid #8a7a52;
      border-radius: 8px;
      background: rgba(20, 15, 30, 0.6);
      color: #ffe14d;
      font-size: 22px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: ease filter 0.3s, ease background 0.2s;
      &:hover{ background: rgba(40, 30, 55, 0.85); }
      flex-direction: column;
      gap: 0;
      line-height: 1;
    }
    // цифра под глазом: сколько партий идёт прямо сейчас
    &__watch-ico{ font-size: 1em; }
    &__watch-num{
      font-size: 0.6em;
      font-weight: 700;
      color: #ffd76a;
      font-variant-numeric: tabular-nums;
    }
    // ответа ещё нет — место под число занято, но числа не видно (иначе кнопка меняет размер)
    &__watch-num--pending{ visibility: hidden; }
    &__radio{
      display: flex;
      align-items: center;
      background: url("../assets/radio.webp") no-repeat;
      background-size: 100% 100%;
      padding: 0.5em 2em;
      color: yellow;
      transition: ease filter 0.3s;
      filter: sepia(100%);
      cursor: pointer;
      margin: 0 1em 1em;
      img{
        margin-right: 1em;
      }
      &:hover{
        filter: sepia(0) contrast(200%);
      }
      &:last-of-type{
        margin-bottom: 1em;
      }
    }
    &__wait{
      opacity: 0.8;
      font-size: 0.85em;
    }
    &__choosers{
      display: flex;
      justify-content: center;
      font-size: 16px;
      width: 100%;
      margin: 0 auto 16px;
      box-sizing: border-box;
    }
    // Подписи силы армии игрока по фракциям + диапазон силы соперника (под кнопками фракций).
    &__powers{
      display: flex;
      justify-content: space-between;
      gap: 1em;
      color: yellow;
      width: 97%;
      padding: 0 16px;
      margin: 0 auto 16px;
      text-transform: none;
      font-size: 15px;
      box-sizing: border-box;
    }
    &__powers--mobile{ display: none; }  // видим только на мобилке (переключение в @media)
    &__power-col{
      text-align: left;
      &--right{
        text-align: right;
      }
    }
    &__power-opp{
      opacity: 0.85;
      font-size: 0.92em;
    }
    // Ползунок допуска отклонения совокупной силы соперника при матчмейкинге.
    &__dev{
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.4em;
      color: yellow;
      width: 100%;
      padding: 0 16px;
      margin: 0 auto 20px;
      text-transform: none;
      font-size: 14px;
      box-sizing: border-box;
      &-label{
        font-size: 0.95em;
      }
      &-slider{
        display: block;
        width: 80%;
        max-width: 320px;
        cursor: pointer;
        accent-color: #ffd76a;
      }
    }
    // СВЁРНУТЫЙ блок настроек соперника-бота: строка-шапка (название + состояние + стрелка) и тело.
    &__botbox{
      width: 100%;
      max-width: 420px;
      margin: 0 auto 16px;
      color: yellow;
      text-transform: none;
      box-sizing: border-box;
      &-head{
        display: flex;
        align-items: center;
        gap: 0.6em;
        width: 100%;
        padding: 8px 14px;
        border: 1px solid #8a7a52;
        border-radius: 8px;
        background: rgba(20, 15, 30, 0.45);
        color: yellow;
        font: inherit;
        font-size: 14px;
        text-transform: none;
        cursor: pointer;
        transition: ease background 0.2s;
        &:hover{ background: rgba(40, 30, 55, 0.6); }
      }
      &-title{ flex: 1 1 auto; text-align: left; }
      // состояние («вкл · Средний» / «выкл») читается в свёрнутом виде — раскрывать ради этого не надо
      &-state{ flex: 0 0 auto; color: #ffcf94; font-size: 0.92em; }
      &-chevron{ flex: 0 0 auto; opacity: 0.7; font-size: 0.8em; }
      &-body{
        border: 1px solid #8a7a52;
        border-top: none;
        border-radius: 0 0 8px 8px;
        padding: 12px 10px 4px;
        .pvp__bot{ margin-bottom: 12px; }
        .pvp__bot--diff{ margin-bottom: 6px; }
      }
      &--open .pvp__botbox-head{ border-radius: 8px 8px 0 0; }
    }
    // Галочка согласия на бота-оппонента (тренировочный матч — без награды/лута).
    &__bot{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.6em;
      color: yellow;
      cursor: pointer;
      width: 100%;
      padding: 0 16px;
      margin: 0 auto 20px;
      text-transform: none;
      font-size: 14px;
      box-sizing: border-box;
      // глобальное правило input{display:none} прячет чекбоксы — здесь возвращаем видимость
      input{
        display: inline-block;
        width: 18px;
        height: 18px;
        cursor: pointer;
      }
      &-text{
        text-align: left;
        font-size: 0.9em;
        small{
          display: block;
          opacity: 0.7;
          font-size: 0.8em;
        }
      }
      // блок выбора сложности бота: подпись сверху, под ней ползунок и три подписи-ступени
      &--diff{
        flex-direction: column;
        align-items: stretch;
        gap: 0.4em;
        cursor: default;
        // 🔴 подпись сложности ПЕРЕНОСИТСЯ, а не расширяет окно (фидбек оунера): карта лобби сжимается
        // по содержимому, и длинная подсказка одной строкой (max-content) раздувала бы её. Ограничиваем
        // ширину текста и разрешаем перенос длинных слов.
        .pvp__bot-text{
          text-align: center;
          max-width: 340px;
          margin: 0 auto;
          overflow-wrap: anywhere;
          b{ color: #ffcf94; }
        }
        // 🔴 ползунок ВНУТРИ &--diff, чтобы перебить глобальное `.pvp__bot input{width/height:18px}`
        // (иначе слайдер сжимался до 18px и не тянулся — «стоит в одной точке», фидбек оунера).
        .pvp__diff-slider{
          display: block;
          width: 90%;
          max-width: 320px;
          height: 26px;
          margin: 0.2em auto 0;
          cursor: pointer;
          accent-color: #ffd76a;
          &:disabled{ opacity: .45; cursor: default; }
        }
      }
    }
    &__diff-ticks{
      display: flex;
      justify-content: space-between;
      width: 90%;
      max-width: 320px;
      margin: 0.1em auto 0;
      font-size: 0.8em;
      color: #ded3f5;
      span{ flex: 1; text-align: center; opacity: .6; }
      span:first-child{ text-align: left; }
      span:last-child{ text-align: right; }
      .pvp__diff-tick--on{ opacity: 1; color: #ffcf94; font-weight: 700; }
    }
  }
  input{
    display: none;
    &:checked{
      &+label{
        filter: sepia(0);
      }
    }
  }
  .btn{
    padding: 2em;
    background: url("../assets/button.webp") no-repeat;
    background-size: 100% 100%;
    border: none;
    cursor: pointer;
    text-transform: uppercase;
    color: yellow;
    font-size: 16px;
    &:hover{
      filter: contrast(200%);
    }
  }
  // ПК: одиночный Старт/Настройки по центру (кнопки Сдаться/Вернуться внутри .pvp__match-actions не трогаем)
  .card-landscape > .pvp-start{ font-size: 16px; padding: 26px 34px; width: 46%; margin: 8px auto 25px; display: block; box-sizing: border-box; }

  @media (max-width: 720px) {
    // Мобильная раскладка (значения из визуального тюнера оунера): карточка — вертикальный поток,
    // каждый блок центрируется своей шириной. Глазик остаётся абсолютным (см. .pvp__watch выше).
    .card-landscape{ display: block; padding: 10px; box-sizing: border-box; }
    .pvp{
      // Game Mode: собственный отступ сверху 30px (значение из тюнера)
      &__header{ font-size: 20px; padding: 10px 20px; width: 60%; margin: 30px auto 14px; text-align: center; }
      // глазик: отступ сверху в px (не центрирование), отсчёт от .pvp__headers
      &__watch{ right: 17px; top: 22px; transform: none; width: 42px; height: 42px; font-size: 18px; }
      // выбор фракции/режима — в КОЛОНКУ (3 радио в ряд не влезают)
      &__choosers{
        flex-direction: column;
        align-items: stretch;
        box-sizing: border-box;
        font-size: 16px;
        width: 90%;
        margin: 0 auto 14px;
        padding: 14px 14px;
      }
      &__radio{
        margin: 0 0 0.7em;
        justify-content: center;
        padding: 0.7em 1em;
      }
      // на мобилке: своя сила ВСЕГДА слева, соперник справа (десктопное выравнивание под кнопки скрываем)
      &__powers{ font-size: 15px; width: 80%; margin: 0 auto 14px; padding: 0 2px; box-sizing: border-box; }
      &__powers--desktop{ display: none; }
      &__powers--mobile{ display: flex; }
      &__dev{ font-size: 14px; width: 80%; margin: 0 auto 20px; padding: 0 2px; box-sizing: border-box; }
      &__bot{ font-size: 14px; width: 90%; margin: 0 auto 20px; padding: 0 2px; box-sizing: border-box; }
      &__bot + &__bot{ margin-bottom: 20px; }
    }
    // Одиночный Старт/Настройки — прямой потомок карточки; кнопки Сдаться/Вернуться внутри
    // .pvp__match-actions под это правило НЕ попадают.
    .card-landscape > .pvp-start{ font-size: 16px; padding: 18px 16px; width: 60%; margin: 0 auto 25px; display: block; }
    .btn{ padding: 1.2em 1em; box-sizing: border-box; }
  }

/* активная партия за выбранную фракцию: две кнопки в ряд (Сдаться / Вернуться) вместо одного Старта */
.pvp__match-actions {
  grid-column-start: 2;
  display: flex; gap: 10px; flex-wrap: wrap;
  .pvp-start { flex: 1 1 45%; margin: 0; }
}
.pvp-start--surrender { filter: hue-rotate(-40deg) saturate(1.3); }
/* 🔴 «Настройки фигур» — ВТОРИЧНОЕ действие: тот же спрайт кнопки, но мельче и без нижнего отступа
   в 25px, иначе он спорит с «В бой» и отрывает от него виджет заданий. */
.card-landscape > .pvp-start--pack {
  width: 38%; padding: 14px 20px; font-size: 14px; margin: -14px auto 18px; filter: saturate(.75);
  /* 🔴 НАДПИСЬ ЖИВЁТ В ОДНУ СТРОКУ (жалоба оунера 2026-09-11: «в мобильной и ТГ версии текст в одну
     строку не влазит, из-за чего вылазит за верхнюю и нижнюю границы кнопки»). Фон кнопки — СПРАЙТ
     `button.webp`, растянутый на 100%×100%, и его рамка нарисована по краям картинки: вторая строка
     текста увеличивает высоту блока, а видимая «шляпка» спрайта остаётся прежней — буквы оказываются
     снаружи. Перенос запрещаем здесь, а место под длинную надпись даём шириной ниже. */
  white-space: nowrap;
}
@media (max-width: 720px) {
  /* 🔴 Ширина в один ряд с «В бой» (60%), а не 52%: «НАСТРОЙКИ ФИГУР» вдвое длиннее «В БОЙ», и на
     узком экране запас в 16 px съедался любым шрифтом крупнее нашего. Вторичность кнопки держат
     шрифт и высота, а не ширина. `min-width` — страховка для экранов от 320 px. */
  .card-landscape > .pvp-start--pack {
    width: 60%; min-width: 190px; max-width: 94%;
    padding: 11px 12px; font-size: 13px; margin: -16px auto 14px;
  }
}
@media (max-width: 720px) {
  .pvp__match-actions { flex-direction: column; }
}

/* Режим наблюдателя: модалка со списком активных партий */
.watch-modal {
  position: fixed;
  inset: 0;
  z-index: 5000;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1em;
}
.watch-modal__box {
  width: min(560px, 96vw);
  max-height: 82vh;
  overflow-y: auto;
  background: #1a1526;
  border: 1px solid #8a7a52;
  border-radius: 12px;
  color: #eee;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.6);
}
.watch-modal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.8em 1em;
  border-bottom: 1px solid #3a3450;
  color: #ffe14d;
  font-weight: 700;
  text-transform: uppercase;
}
.watch-modal__close {
  border: none;
  background: none;
  color: #ccc;
  font-size: 1.2em;
  cursor: pointer;
}
.watch-modal__empty { padding: 2em 1em; text-align: center; color: #aaa; }
/* кнопки подтверждения (сдача) — в стилистике окна наблюдателя, а не системного диалога */
.watch-modal__acts { display: flex; gap: 0.6em; justify-content: center; padding: 0 1em 1.2em; }
.watch-modal__acts button {
  padding: 0.5em 1.2em;
  border: 1px solid #6b5a3a;
  border-radius: 4px;
  background: #241d14;
  color: #e8dcc0;
  cursor: pointer;
}
.watch-modal__acts button:first-child { background: #4a2320; border-color: #8a4a40; }
.watch-modal__list { list-style: none; margin: 0; padding: 0.4em; }
.watch-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto;
  align-items: center;
  gap: 0.5em;
  padding: 0.6em 0.7em;
  border-radius: 8px;
  cursor: pointer;
  transition: ease background 0.15s;
}
.watch-row:hover { background: rgba(255, 255, 255, 0.06); }
.watch-row__side { display: flex; align-items: center; gap: 0.4em; min-width: 0; }
.watch-row__side--right { justify-content: flex-end; }
.watch-row__name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 8em; }
.watch-row__pow { color: #ffcf4d; font-variant-numeric: tabular-nums; }
.watch-row__vs { color: #999; font-size: 0.85em; }
.watch-row__fight { color: #ff6a5c; font-size: 1.1em; }
.watch-row__meta { display: flex; gap: 0.7em; color: #bbb; font-size: 0.82em; grid-column: 1 / -1; justify-content: center; }

/* Виджет заданий дня в лобби (макет docs/daily/, секция «виджет в лобби PvP») */
.pvp__daily {
  display: flex;
  align-items: center;
  gap: 0.8em;
  width: 100%;
  max-width: 460px;
  margin: 0.9em auto 0.2em;
  padding: 0.6em 0.85em;
  box-sizing: border-box;
  border-radius: 12px;
  border: 1px solid rgba(255, 200, 90, 0.4);
  background: rgba(0, 0, 0, 0.32);
  color: #eee;
  text-decoration: none;
  position: relative;
}
.pvp__daily:hover { border-color: rgba(255, 210, 120, 0.75); }
/* каркас до ответа `/daily`: место занято, содержимое не видно (иначе таблица лидеров прыгает) */
.pvp__daily--pending { visibility: hidden; }

/* 🔴 КАРКАСЫ ДО ОТВЕТА СЕРВЕРА: место занято, содержимое не видно. Экран лобби собирается из
   ПЯТИ разных ответов, и каждый, приходя, двигал всё, что ниже (жалоба оунера 2026-08-30
   «интерфейс постоянно прыгает»). */
.pvp__powers--pending { visibility: hidden; }
.pvp__wait--pending { visibility: hidden; }
.pvp__daily-ico { font-size: 1.5em; }
.pvp__daily-body { flex: 1; min-width: 0; }
.pvp__daily-top { display: flex; align-items: baseline; gap: 0.6em; }
.pvp__daily-title { font-weight: 700; font-size: 0.92em; color: #f6ecd2; }
.pvp__daily-pts { color: #ffcf94; font-size: 0.85em; font-variant-numeric: tabular-nums; margin-left: auto; }
.pvp__daily-bar {
  display: block;
  height: 6px;
  margin: 5px 0 4px;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
}
.pvp__daily-bar i { display: block; height: 100%; background: linear-gradient(90deg, #ffcf94, #e0803a); }
.pvp__daily-note { font-size: 0.72em; color: #b3a5d8; }
.pvp__daily-badge {
  position: absolute;
  top: -0.5em;
  right: -0.4em;
  min-width: 1.5em;
  padding: 0.1em 0.4em;
  border-radius: 1em;
  background: linear-gradient(135deg, #ffd257, #f0a13a);
  color: #4a2f00;
  font-size: 0.72em;
  font-weight: 700;
  text-align: center;
}

/* ОБУЧЕНИЕ: чужая фракция закрыта до конца первой партии */
.pvp__radio--locked { filter: grayscale(1) brightness(.55); cursor: default; }
.pvp__tutlock { text-align: center; font-size: .8em; color: #ffe0b0; margin-top: 6px; }
</style>
